import {graphql, useFragment} from 'react-relay'

import {getBuildOvertimeInfo} from '../../../../utils/buildOvertime'

import type {SnapshotDependenciesCountersFragment$key} from './__generated__/SnapshotDependenciesCountersFragment.graphql'

const fragment = graphql`
  fragment SnapshotDependenciesCountersFragment on Builds {
    build {
      status
      state
      failedToStart
      runningInfo {
        elapsedSeconds
        estimatedTotalSeconds
      }
    }
  }
`

export const useSnapshotDependenciesCounters = (
  key: SnapshotDependenciesCountersFragment$key | null,
) => {
  const builds = useFragment(fragment, key)?.build ?? []
  let finishedFailed = 0
  let finishedSuccessful = 0
  let queued = 0
  let canceled = 0
  let failedToStart = 0
  let runningFailed = 0
  let runningSuccessful = 0
  let overdue = 0

  builds.forEach(build => {
    if (build.status === 'SUCCESS') {
      if (build.state === 'running') {
        runningSuccessful += 1
      } else {
        finishedSuccessful += 1
      }
    }

    if (build.status === 'FAILURE') {
      if (build.failedToStart) {
        failedToStart += 1
      } else if (build.state === 'running') {
        runningFailed += 1
      } else {
        finishedFailed += 1
      }
    }

    if (build.status === 'UNKNOWN') {
      canceled += 1
    }

    if (build.state === 'queued') {
      queued += 1
    }

    if (getBuildOvertimeInfo(build.runningInfo).isOvertime) {
      overdue += 1
    }
  })

  return {
    finishedFailed,
    finishedSuccessful,
    queued,
    canceled,
    failedToStart,
    runningFailed,
    runningSuccessful,
    overdue,
  }
}
